module.exports = __webpack_public_path__ + "static/media/FlyBirdsBox_RoseGold_Icons-phone.ded05255.png";